export enum TrafficPatterns {
    INCREASE_BY_LEVEL = 'INCREASE_BY_LEVEL',
    INCREASE_BY_LEVEL_WITH_BACK_PRESSURE = 'INCREASE_BY_LEVEL_WITH_BACK_PRESSURE',
    STEADY = 'STEADY',
    STEADY_WAVE = 'STEADY_WAVE',
}

export const TrafficPatternNames = {
    [TrafficPatterns.INCREASE_BY_LEVEL]: 'Increase by Level',
    [TrafficPatterns.INCREASE_BY_LEVEL_WITH_BACK_PRESSURE]: 'Increase by Level with Back Pressure',
    [TrafficPatterns.STEADY]: 'Steady',
    [TrafficPatterns.STEADY_WAVE]: 'Steady Wave',
}

export const TrafficPatternShortNames = {
    [TrafficPatterns.INCREASE_BY_LEVEL]: 'Inc.',
    [TrafficPatterns.INCREASE_BY_LEVEL_WITH_BACK_PRESSURE]: 'Inc. w/ BP',
    [TrafficPatterns.STEADY]: 'Steady',
    [TrafficPatterns.STEADY_WAVE]: 'Wave',
}


const MIN_IOPS_SCALE = 0.5;
const MAX_IOPS_SCALE = 2.0;

const IOPS_SCALE_BY_LEVEL = [
    { totalIOPS: 1000, minScale: 0.9, maxScale: 1.2 },
    { totalIOPS: 10000, minScale: 0.95, maxScale: 1.1 },
    { totalIOPS: 100000, minScale: 0.98, maxScale: 1.05 },
    { totalIOPS: 1000000, minScale: 0.99, maxScale: 1.02 },
]

const IOPS_SCALE_BY_LEVEL_STEADY_WAVE = [
    { totalIOPS: 1000, minScale: 0.9, maxScale: 1.1 },
    { totalIOPS: 10000, minScale: 0.95, maxScale: 1.05 },
    { totalIOPS: 100000, minScale: 0.98, maxScale: 1.02 },
    { totalIOPS: 1000000, minScale: 0.99, maxScale: 1.01 },
]

//Computes a random fractional number between two values
export function getRandomFractionalNumber(min: number, max: number) {
    return Math.random() * (max - min) + min;
}


//Gets the max and min IOPS scale for a given total IOPS
export function getNextIOPSScaleIncreaseLevel(totalIOPS: number): number {
    let minScale = MIN_IOPS_SCALE;
    let maxScale = MAX_IOPS_SCALE;
    IOPS_SCALE_BY_LEVEL.forEach((level) => {
        if (totalIOPS >= level.totalIOPS) {
            minScale = level.minScale;
            maxScale = level.maxScale;
        }
    });

    return getRandomFractionalNumber(minScale, maxScale);
}

export function getNextIOPSScaleIncreaseLevelWithBackPressure(totalIOPS: number, lastPercentSuccess: number = 100): number {
    let minScale = MIN_IOPS_SCALE;
    let maxScale = MAX_IOPS_SCALE;
    IOPS_SCALE_BY_LEVEL.forEach((level) => {
        if (totalIOPS >= level.totalIOPS) {
            minScale = level.minScale;
            maxScale = level.maxScale;
        }
    });

    //If the last cycle was not 100% successful, reverse the min and max scale
    if (lastPercentSuccess < 100) {
        const temp = minScale;
        minScale = 2 - maxScale;
        maxScale = 2 - temp;
    }

    return getRandomFractionalNumber(minScale, maxScale);
}

export function getNextIOPSScaleSteadyWave(totalIOPS: number): number {
    let minScale = MIN_IOPS_SCALE;
    let maxScale = MAX_IOPS_SCALE;
    IOPS_SCALE_BY_LEVEL_STEADY_WAVE.forEach((level) => {
        if (totalIOPS >= level.totalIOPS) {
            minScale = level.minScale;
            maxScale = level.maxScale;
        }
    });

    return getRandomFractionalNumber(minScale, maxScale);
}

export function getNextIOPSScale(pattern: TrafficPatterns, totalIOPS: number, lastPercentSuccess: number = 100) {
    switch (pattern) {
        case TrafficPatterns.INCREASE_BY_LEVEL:
            return getNextIOPSScaleIncreaseLevel(totalIOPS);
        case TrafficPatterns.INCREASE_BY_LEVEL_WITH_BACK_PRESSURE:
            return getNextIOPSScaleIncreaseLevelWithBackPressure(totalIOPS, lastPercentSuccess);
        case TrafficPatterns.STEADY:
            return 1;
        case TrafficPatterns.STEADY_WAVE:
            return getNextIOPSScaleSteadyWave(totalIOPS);
    }
}